import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EErrorCodes = {
	nameAlreadyExists: 'name_already_exists',
	legalNameAlreadyExists: 'legal_name_already_exists',
	emailAlreadyExists: 'email_already_exists',
	approvalUnitHaveAttach: 'approval_unit_have_attach',
	linkSiteOutOfRadius: 'link_site_out_of_radius',
	couldNotApplyKpiToSites: 'could_not_apply_kpi_to_sites',
	notFoundAggregationType: 'not_found_aggregation_type',
	unauthorized: 'unauthorized',
	goldenSettingsNotSet: 'golden_settings_not_set',
	assetTypeNameMustBeUnique: 'asset_type_name_must_be_unique',
	assetSubTypeNameMustBeUnique: 'asset_sub_type_name_must_be_unique',
	kaiAssistantNameMustBeUnique: 'kai_assistant_name_already_exists',
	kpiPresetAlreadyExists: 'kpi_preset_already_exists',
	projectCodeMustBeUnique: 'code_already_exists',
	projectCodeMustStartWithUppercase: 'code_must_start_with_uppercase',
	projectCodeMustHaveAtList2Characters: 'not_valid_code_length',
	portalFolderNameMustBeUnique: 'folder_name_already_exists',
	uniqueIpAddress: 'unique_ip_address',
	notValidIpAddress: 'not_valid_ip_address',
	uniqueName: 'unique_name',
	nameMustBeUnique: 'name_must_be_unique',
	templateNameMustBeSize: 'template_name_must_be_size',
	nameSize: 'name_must_be_size',
	namePattern: 'name_must_be_pattern',
	notValidNameLength: 'not_valid_name_length',
	networkElementNotFound: 'network_elements_not_found',
	networkElementNotEnabled: 'network_element_not_enabled',
	networkElementNotConnected: 'network_element_not_connected',
	templateNamePattern: 'template_name_pattern',
	pathDuIsNotValid: 'path_du_is_not_valid',
	pathCuIsNotValid: 'path_cu_is_not_valid',
	taskNotAvailable: 'task_not_available',
	permissionError: 'You do not have permissions to perform this action',
	emailWrongFormat: 'user_email_must_b_not_email',
} as const;

export type TErrorCodes = TValueOfStringRecord<typeof EErrorCodes>

export const PermissionErrorCause = 'permission_error';
